export const FILE_TYPE = {
  DOCX: 'DOCX',
  PDF: 'PDF',
};
